<!-- Device toggle — sits above the sub-bar so that row stays readable. Every
     audit request carries the selected profile as `device=`, so switching
     re-reads the whole report. -->
<div class="device-row" *ngIf="showDeviceToggle">
  <span class="device-label">Platform</span>
  <div class="device-toggle">
    <button
      *ngFor="let d of deviceStates"
      type="button"
      class="device-btn"
      [class.active]="d.available && activeDevice === d.key"
      [class.unavailable]="!d.available"
      [matTooltip]="d.tooltip"
      matTooltipPosition="above"
      (click)="selectDevice(d)"
    >
      <mat-icon>{{ d.icon }}</mat-icon>
      {{ d.label }}
      <!-- Not run for this profile yet — clicking offers to add it. -->
      <mat-icon class="device-add" *ngIf="!d.available">add</mat-icon>
      <span class="device-running" *ngIf="d.running">·&nbsp;running</span>
    </button>
  </div>
</div>

<div class="ov-subbar" *ngIf="selectedTask">
  <div class="ov-subbar-left">
    <span class="freq-badge">{{ getAuditFrequencyLabel() }}</span>
    <span class="period-date" *ngIf="periodMain">{{ periodMain }}</span>
    <span class="period-compare" *ngIf="periodCompare">{{
      periodCompare
    }}</span>
  </div>
  <div class="ov-subbar-right">
    <span class="bench-label" *ngIf="competitors.length"
      >Benchmarking against</span
    >
    <button
      *ngFor="let comp of competitors"
      class="comp-chip"
      [class.active]="isActiveCompetitor(comp)"
      (click)="selectCompetitor(comp)"
    >
      {{ getCompChipLabel(comp) }}
    </button>
    <button
      class="comp-chip comp-chip--add"
      *ngIf="selectedTask?.type !== 'Crawler' && !isShare"
      (click)="addCompetitor()"
    >
      + Add competitor
    </button>
  </div>
</div>
